import { MapPin, MessageSquareText } from 'lucide-react';

import { stageName } from '../../utils/ordersOperationsPresentation';

function money(value) {
  return new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(Number(value || 0));
}

export default function FulfillmentOrderSummary({ order }) {
  const itemCount = (order.items || []).reduce((sum, item) => sum + (Number(item.requiredQuantity) || 0), 0);

  return (
    <section aria-labelledby="fulfillment-order-summary" className="rounded-2xl border border-neutral-200 bg-neutral-50/70 p-4 dark:border-neutral-800 dark:bg-neutral-900/60">
      <h3 id="fulfillment-order-summary" className="text-sm font-semibold">Order context</h3>
      <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-3 text-sm sm:grid-cols-3 lg:grid-cols-5">
        <div className="min-w-0"><dt className="text-xs text-neutral-500">Customer</dt><dd className="mt-1 break-words font-medium">{order.customer || 'Customer unavailable'}</dd></div>
        <div><dt className="text-xs text-neutral-500">Payment</dt><dd className="mt-1 font-medium">{order.payment ? `${order.payment.method || 'Method unavailable'} · ${order.payment.status || 'Status unavailable'}` : 'Payment unavailable'}</dd></div>
        <div><dt className="text-xs text-neutral-500">Order total</dt><dd className="mt-1 font-medium tabular-nums">{money(order.total)}</dd></div>
        <div><dt className="text-xs text-neutral-500">Items</dt><dd className="mt-1 font-medium">{itemCount} {itemCount === 1 ? 'unit' : 'units'}</dd></div>
        <div><dt className="text-xs text-neutral-500">Current stage</dt><dd className="mt-1 font-medium">{stageName(order.stage)}</dd></div>
      </dl>

      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <div className="flex gap-3 rounded-xl border border-neutral-200 bg-white p-3 dark:border-neutral-800 dark:bg-neutral-950">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-neutral-500" aria-hidden="true" />
          <div className="min-w-0"><p className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Delivery address</p><p className="mt-1 break-words text-sm leading-5">{order.deliveryAddress || 'Address unavailable'}</p></div>
        </div>
        <div className="flex gap-3 rounded-xl border border-neutral-200 bg-white p-3 dark:border-neutral-800 dark:bg-neutral-950">
          <MessageSquareText className="mt-0.5 h-4 w-4 shrink-0 text-neutral-500" aria-hidden="true" />
          <div className="min-w-0"><p className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Shopper note</p><p className="mt-1 break-words text-sm leading-5">{order.customerNote || 'No shopper note provided.'}</p></div>
        </div>
      </div>
    </section>
  );
}
